import Axios from 'axios'
import apiURL from './apiURL'

class AxiosManagerClass {
  constructor() {
    this.handleInvalidToken = null
    this.instance = Axios.create({
      baseURL: apiURL,
      withCredentials: true
    });
  }

  static setInvalidTokenCallback(callback) {
    this.handleInvalidToken = callback
  }
}

// Create Axios Manager
const AxiosManager = new AxiosManagerClass()

// // Methods For Interceptors
const setCsrfForRequest = (config) => {
  const csrf = localStorage.getItem('csrf-token')
  if (csrf) {
    config.headers['CSRF-TOKEN'] = csrf
  }
};

const getCsrfFromResponse = (response) => {
  if (response.headers['csrf-token']) {
    localStorage.setItem('csrf-token', response.headers['csrf-token'])
  }
};

const checkTokenValidityFromResponse = (error) => {
  const tokenIsInvalid = error?.response?.data?.errors?.user === 'Invalid Token'
  // We'll probably handle this another time
  // const callbackIsValid = typeof AxiosManager.handleInvalidToken === 'function'
  // if (tokenIsInvalid && callbackIsValid) {
    // AxiosManager.handleInvalidToken()
  if (tokenIsInvalid) {
    window.history.pushState({ urlPath: '/landing' }, null, 'landing')
    return false
  } else {
    return true
  }
};

// Request Interceptor
AxiosManager.instance.interceptors.request.use(
  async function (config) {
    // Do something before request is sent
    setCsrfForRequest(config)
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
);

// Response Interceptor
AxiosManager.instance.interceptors.response.use(
  async function (response) {
    // Do something with response data
    getCsrfFromResponse(response)
    return response
  },
  function (error) {
    // Do something with response error
    if (!checkTokenValidityFromResponse(error)) {
      // we return an empty object to prevent
      // toast notifications from displaying
      return Promise.reject({})
    }
    return Promise.reject(error)
  }
)

const axios = AxiosManager.instance
export default axios
export { AxiosManager }
